// extracted by mini-css-extract-plugin
export default {"brandPromo":"LF-z","carousel":"MF-z"};